import { ROUTES } from './constants';

const isSafeInternalPath = (value?: string | null): value is string => {
  if (!value || typeof value !== 'string') return false;
  return value.startsWith('/') && !value.startsWith('//');
};

const normalizeAuthRedirect = (value?: string | null): string | null => {
  if (!isSafeInternalPath(value)) {
    return null;
  }

  return value;
};

interface ResolvePostAuthRouteOptions {
  stateFromPathname?: string;
  queryRedirect?: string | null;
  currentPathname?: string;
  fallbackRoute?: string;
}

export const resolvePostAuthRoute = ({
  stateFromPathname,
  queryRedirect,
  fallbackRoute = ROUTES.home,
}: ResolvePostAuthRouteOptions): string => {
  const queryPath = normalizeAuthRedirect(queryRedirect);
  if (queryPath) {
    return queryPath;
  }

  const fromPath = normalizeAuthRedirect(stateFromPathname);
  if (fromPath) {
    return fromPath;
  }

  return fallbackRoute;
};

export const getAuthRedirectFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search);
  return params.get('redirect') || params.get('returnTo') || params.get('next');
};
